import { createFileRoute, Link } from "@tanstack/react-router";
import type { JSX } from "react";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";
import Plus from "@repo/icons/default/Plus";

import { BlogExhibitionDrawer } from "@/components/blog/blog-exhibition-drawer";
import { BlogPostList } from "@/components/blog/blog-post-list";
import { SiteConfigurationDrawer } from "@/components/blog/site-configuration-drawer";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { Fab } from "@/components/ui/fab/fab";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";

const BlogPageQuery = graphql(`
  query BlogPageQuery {
    usuariosDominiosRegistros(limit: 1, where: { ativo: { _eq: true } }) {
      ativo
      dominio
      dataExpiracao
    }
    configuracaoSite {
      mostrarBlog
    }
  }
`);

const BlogPage = (): JSX.Element => {
  const queryData = useGraphQL(BlogPageQuery);
  const { data } = queryData;
  const domain = data?.usuariosDominiosRegistros.length
    ? data.usuariosDominiosRegistros[0]
    : null;
  const showBlog = data?.configuracaoSite?.mostrarBlog;
  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Blog" />
      </HeaderRoot>
      <Page className="px-0">
        <AsyncDataWrapper {...queryData}>
          <BlogPostList />

          <Link to="/settings/blog/create">
            <Fab isPageWithNav={false}>
              <Plus size={32} className="fill-white" />
            </Fab>
          </Link>
          {data ? (
            <>
              <BlogExhibitionDrawer show={!showBlog && Boolean(domain)} />
              <SiteConfigurationDrawer show={!domain} />{" "}
            </>
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/blog/")({
  component: BlogPage,
});
